import { render, staticRenderFns } from "./OptionPropertyAttorneysPrimaryWorkTogetherYN.vue?vue&type=template&id=10dfd586"
import script from "./OptionPropertyAttorneysPrimaryWorkTogetherYN.vue?vue&type=script&lang=js"
export * from "./OptionPropertyAttorneysPrimaryWorkTogetherYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports